<template>
  <div>
    <div class="calculator-input-values">
      <h5>Данные для расчета</h5>

      <p class="calculator-comment">Укажите параметры</p>
      <table>
        <tbody>
          <tr>
            <td v-if="kg25">Толщина слоя, мм</td>
            <td v-else>Количество слоев</td>
            <td>
              <input
                v-model="thickness"
                id="calc-polymfloor-thickness"
                type="number"
                placeholder="0"
                :min="minThickness"
                max="150"
              />
            </td>
          </tr>

          <tr>
            <td>Площадь поверхности, м<sup>2</sup></td>
            <td>
              <input
                v-model="area"
                id="calc-polymfloor-square"
                type="number"
                placeholder="0"
                min="1"
                max="500"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="calculator-output-values">
      <h5>Результаты расчета</h5>
      <table>
        <thead>
          <tr>
            <th colspan="2">Результаты расчета</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Необходимое количество материала, кг</td>
            <td
              class="calc-result-value-container"
              id="calc-polymfloor-need-material-quantity"
              width="100"
            >
              {{ weight }}
            </td>
          </tr>
          <tr v-if="kg5">
            <td>Необходимое количество канистр по 5 кг, шт</td>
            <td id="calc-polymfloor-need-25-packs-quantity">
              {{ pack5Count }}
            </td>
          </tr>
          <tr v-if="kg10">
            <td>Необходимое количество канистр по 10 кг, шт</td>
            <td id="calc-polymfloor-need-25-packs-quantity">
              {{ pack10Count }}
            </td>
          </tr>
          <tr v-if="kg25">
            <td>Необходимое количество мешков по 25 кг, шт</td>
            <td id="calc-polymfloor-need-25-packs-quantity">
              {{ pack25Count }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.thickness = this.minThickness;
  },
  data() {
    return {
      thickness: 1,
      area: 10,
    };
  },
  props: {
    multiplier: {
      type: Number,
      default: 0,
    },
    minThickness: Number,
    kg5: Boolean,
    kg10: Boolean,
    kg25: Boolean,
  },
  computed: {
    weight() {
      return (this.thickness * this.area * this.multiplier).toFixed(2);
    },
    pack5Count() {
      return Math.ceil(this.weight / 5);
    },
    pack10Count() {
      return Math.ceil(this.weight / 10);
    },
    pack25Count() {
      return Math.ceil(this.weight / 25);
    },
  },
};
</script>

<style lang="scss" scoped></style>
